var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-expand navbar-light bg-white topbar static-top shadow col-sm-12"
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", {}, [
        _c(
          "button",
          { staticClass: "btn", on: { click: _vm.openPoiListModal } },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" " + _vm._s(_vm.$t("txtBtnListe")))
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass:
            "d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
        },
        [
          _c(
            "div",
            { staticClass: "input-group", attrs: { id: "v-tour-step-0" } },
            [
              _c("autocomplete", {
                attrs: {
                  search: _vm.search,
                  placeholder: "Search for a Point",
                  "aria-label": "Search for a Point",
                  "get-result-value": _vm.getResultValue
                },
                on: {
                  submit: function($event) {
                    return _vm.$emit("selectedPoi", $event)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "navbar-nav ml-auto" }, [
        _c(
          "li",
          { staticClass: "nav-item dropdown no-arrow d-sm-none" },
          [
            _c("autocomplete", {
              attrs: {
                search: _vm.search,
                placeholder: "Search for a Point",
                "aria-label": "Search for a Point",
                "get-result-value": _vm.getResultValue
              },
              on: {
                submit: function($event) {
                  return _vm.$emit("selectedPoi", $event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary",
              on: { click: _vm.openGpsTrackerListModal }
            },
            [
              _c("i", {
                staticClass: "fa fa-cog",
                staticStyle: { width: "1em" }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("GpsTrackerListModal", { ref: "gpsTrackerListModal" }),
      _vm._v(" "),
      _c("PoiListModal", {
        ref: "poiListModal",
        attrs: { pois: _vm.pois },
        on: {
          selectedPoi: function($event) {
            return _vm.$emit("selectedPoi", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-link d-md-none rounded-circle mr-3",
        attrs: { id: "sidebarToggleTop" }
      },
      [_c("i", { staticClass: "fa fa-bars" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }